import { render, staticRenderFns } from "./DefineGame.vue?vue&type=template&id=33bfea82&scoped=true&"
import script from "./DefineGame.vue?vue&type=script&lang=js&"
export * from "./DefineGame.vue?vue&type=script&lang=js&"
import style0 from "./DefineGame.vue?vue&type=style&index=0&id=33bfea82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33bfea82",
  null
  
)

export default component.exports